// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.volume-slider-container {
  position: absolute;
  width: calc(100% - 20px);
  /* top: 36px; */
  height: calc(100% - 11px);
}

.volume-slider-track-container {
  /* padding: 5px;
  position: relative;
  top: 24px; */
  position: absolute;
  width: 100%;
  /* width: calc(100% - 20px); */
  /* top: 31px; */
  top: 21px;
  height: calc(100% + 20px);
}

.volume-slider-heading {
  position: relative;
  height: 14px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #243547;
}

.volume-slider-heading-value-span {
  font-weight: bold;
}

.volume-slider-footer {
  position: absolute;
  bottom: 0px;
  /* margin-top: 20px; */
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  font-size: 12px;
  padding: 0 5px;
}

.volume-change-btn {
  border: none;
  background-color: transparent;
  padding: 3px;
}

.volume-change-btn:hover {
  /* border: 1px solid black; */
  background-color: #e2e8ee;
}

.volume-slider-thumb {
  border-radius: 8px;
  position: absolute;
  color: transparent;
  /* width: 16px;
  height: 16px; */
  top: 5px;
  z-index: 5;
  width: 16px;
  height: 16px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 2px #243547;
  background-color: #fff;
}

.volume-slider-thumb:focus {
  outline: 3px solid #4696eb;
}

.volume-slider-track {
  width: 100%;
  position: absolute;
  height: 8px;
  top: 10px;
  left: 0;
  border-radius: 4px;
  border: solid 1px #8493a3;
  /* background-color: #f2f5f8; */
}

.volume-slider-track-elapsed {
  /* border: solid 1px #475b70;
  background-color: #475b70; */
  background-color: #243547;
  height: 8px;
  position: absolute;
  left: 0;
  top: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/VolumeSlider/VolumeSlider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;;cAEY;EACZ,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB;iBACe;EACf,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE;8BAC4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,4BAA4B;EAC5B,+BAA+B;AACjC","sourcesContent":[".volume-slider-container {\n  position: absolute;\n  width: calc(100% - 20px);\n  /* top: 36px; */\n  height: calc(100% - 11px);\n}\n\n.volume-slider-track-container {\n  /* padding: 5px;\n  position: relative;\n  top: 24px; */\n  position: absolute;\n  width: 100%;\n  /* width: calc(100% - 20px); */\n  /* top: 31px; */\n  top: 21px;\n  height: calc(100% + 20px);\n}\n\n.volume-slider-heading {\n  position: relative;\n  height: 14px;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n  text-align: center;\n  color: #243547;\n}\n\n.volume-slider-heading-value-span {\n  font-weight: bold;\n}\n\n.volume-slider-footer {\n  position: absolute;\n  bottom: 0px;\n  /* margin-top: 20px; */\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  width: 100%;\n  font-size: 12px;\n  padding: 0 5px;\n}\n\n.volume-change-btn {\n  border: none;\n  background-color: transparent;\n  padding: 3px;\n}\n\n.volume-change-btn:hover {\n  /* border: 1px solid black; */\n  background-color: #e2e8ee;\n}\n\n.volume-slider-thumb {\n  border-radius: 8px;\n  position: absolute;\n  color: transparent;\n  /* width: 16px;\n  height: 16px; */\n  top: 5px;\n  z-index: 5;\n  width: 16px;\n  height: 16px;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);\n  border: solid 2px #243547;\n  background-color: #fff;\n}\n\n.volume-slider-thumb:focus {\n  outline: 3px solid #4696eb;\n}\n\n.volume-slider-track {\n  width: 100%;\n  position: absolute;\n  height: 8px;\n  top: 10px;\n  left: 0;\n  border-radius: 4px;\n  border: solid 1px #8493a3;\n  /* background-color: #f2f5f8; */\n}\n\n.volume-slider-track-elapsed {\n  /* border: solid 1px #475b70;\n  background-color: #475b70; */\n  background-color: #243547;\n  height: 8px;\n  position: absolute;\n  left: 0;\n  top: 10px;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
